import { UNGROUPED_RESOURCES_GROUP_ID } from '@/console/features/groups/components/group-list/group-list.constants';

import { api } from '../../_generated/api/assets-api.generated';

export const licensesApi = api.enhanceEndpoints({
  addTagTypes: ['License', 'Groups'],
  endpoints: {
    ReadAllLicenses: {
      providesTags: (_, __, args) => {
        const tags = [{ type: 'License' as const, id: 'LIST' }];
        const filteredGroup = args?.filter?.groupId;
        const groupId = filteredGroup?.contains ?? UNGROUPED_RESOURCES_GROUP_ID;
        if (filteredGroup) {
          return [...tags, { type: 'Groups' as const, id: groupId }];
        }
        return tags;
      },
    },
    CreateLicense: {
      invalidatesTags: [
        { type: 'License' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    DeleteLicense: {
      invalidatesTags: [
        { type: 'License' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
    UpdateLicense: {
      invalidatesTags: [
        { type: 'License' as const, id: 'LIST' },
        'Groups' as const,
      ],
    },
  },
});

export const {
  useReadAllLicensesQuery,
  useCreateLicenseMutation,
  useCompleteLicenseMultipartUploadMutation,
  useLazyDownloadLicenseQuery,
  useDeleteLicenseMutation,
  useUpdateLicenseMutation,
  useReadLicenseNamesForRoleRowQuery,
} = licensesApi;
